import { render, staticRenderFns } from "./BpmCommonDefList.vue?vue&type=template&id=720e4b56&scoped=true&"
import script from "./BpmCommonDefList.vue?vue&type=script&lang=js&"
export * from "./BpmCommonDefList.vue?vue&type=script&lang=js&"
import style0 from "./BpmCommonDefList.vue?vue&type=style&index=0&id=720e4b56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "720e4b56",
  null
  
)

export default component.exports